import { CopyGuestLinkController } from './copy-guest-link.controller'

function copyGuestLinkDirective () {
  return {
    restrict: 'E',
    scope: {
      link: '='
    },
    templateUrl: '/core/directives/copy-guest-link/copy-guest-link.html?$$REVISION$$',
    controller: CopyGuestLinkController
  }
}
export { copyGuestLinkDirective }
